/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'
import { Theme } from '@themes/theme'

const Color = (theme: Theme) => css`
  width: inherit;
  height: auto;

  #newBadgeBg {
    fill: ${theme.color.red};
  }

  #newBadgeTxt {
    fill: ${theme.color.white};
  }
`
export default class NewBadgeIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" css={Color} className="new-badge-ico">
        <g id="그룹_12430" data-name="그룹 12430" transform="translate(13651 363)">
          <circle id="newBadgeBg" data-name="알림 닷" cx="8" cy="8" r="8" transform="translate(-13651 -363)"
                  fill="#dc2323"/>
          <path id="newBadgeTxt" data-name="합치기 299"
                d="M-11.636-256.691l-2.739-4.582v4.582H-16V-264h1.582l2.739,4.576V-264h1.626v7.309Z"
                transform="translate(-13629.905 -94.655)" fill="#fff"/>
        </g>
      </svg>
    )
  }
}
